import { render, staticRenderFns } from "./AddExpertModel.vue?vue&type=template&id=0f248821&scoped=true"
import script from "./AddExpertModel.vue?vue&type=script&lang=js"
export * from "./AddExpertModel.vue?vue&type=script&lang=js"
import style0 from "./AddExpertModel.vue?vue&type=style&index=0&id=0f248821&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f248821",
  null
  
)

export default component.exports